// extracted by mini-css-extract-plugin
module.exports = {"ProjectContainer":"style_ProjectContainer__3Mo_W","Buttons":"style_Buttons__3xUDR","Button":"style_Button__1tcmK"};